import React from 'react';
import PropTypes from 'prop-types';

const Content = React.forwardRef(({ children }, ref) => {
  return <div className="content" ref={ref}>{children}</div>;
});

Content.displayName = 'Content';

Content.propTypes = {
  children: PropTypes.node,
};

export default Content;
